// extracted by mini-css-extract-plugin
export default {"cartContainer":"cartItem_cartContainer__RIBUo","cartImg":"cartItem_cartImg__eIB+u","quantityContainer":"cartItem_quantityContainer__Kznyv","action":"cartItem_action__QVFXb"};